import InputComponent from "V2.0/components/InputComponent";
import { CoachTriggerType } from "../types";

export default TriggerCoachTypeSelect;

function TriggerCoachTypeSelect(props) {
  const { coachTriggerState, setCoachTriggerState, isUnlocked } = props;

  return (
    <InputComponent
      type="select"
      label="Trigger Type"
      name="triggerType"
      value={coachTriggerState.triggerType}
      onChange={(e) =>
        setCoachTriggerState((prev) => {
          return {
            ...prev,
            triggerType: e.target.value,
          };
        })
      }
      options={[
        { value: CoachTriggerType.EveryTurn, label: "Every Turn", id: 0 },
        { value: CoachTriggerType.Conditional, label: "Conditional", id: 1 },
        { value: CoachTriggerType.LLMBased, label: "LLM Based", id: 2 },
      ]}
      disabled={!isUnlocked}
    />
  );
}
